import { render, staticRenderFns } from "./MonthKaoHe.vue?vue&type=template&id=564f97e6&"
import script from "./MonthKaoHe.vue?vue&type=script&lang=js&"
export * from "./MonthKaoHe.vue?vue&type=script&lang=js&"
import style0 from "./MonthKaoHe.vue?vue&type=style&index=0&id=564f97e6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports